<div class="border-card">
    <div [ngClass]="{'border': border }" class="header-card">
        <div class="title-container">
            <h2 class="title-card">{{title}}</h2>
            <h3 #subtitleColorRef class="subtitle-card">{{subtitle}}</h3>
        </div>
        <div class="icons-card">
            <button #emptyIconRef *ngIf="emptyIcon" class="empty-button" (click)="activeEmpty()"
                [title]="emptyIcon.title ? emptyIcon.title : ''">
                <frg-inline-svg [fill]="emptyIcon.fill" [stroke]="emptyIcon.stroke" [src]="emptyIcon.src">
                </frg-inline-svg>
            </button>
            <button #emptyIcon1Ref *ngIf="emptyIcon1" class="empty-button" (click)="activeEmpty1()"
            [title]="emptyIcon1.title ? emptyIcon1.title : ''">
            <frg-inline-svg [fill]="emptyIcon1.fill" [stroke]="emptyIcon1.stroke" [src]="emptyIcon1.src">
            </frg-inline-svg>
            </button>
            <button style="margin-left:2rem;" #emptyIcon2Ref *ngIf="emptyIcon2 && isEmptyIcon2Active" class="empty-button" (click)="activeEmpty2()" [title]="emptyIcon2.title ? emptyIcon2.title : ''">
                <frg-inline-svg class="icon" [fill]="emptyIcon2.fill" [stroke]="emptyIcon2.stroke" [src]="emptyIcon2.src">
                </frg-inline-svg>
            </button>
            <button #fullIconRef *ngIf="fullIcon" class="full-button" (click)="activeFull()" [title]="fullIcon.title ? fullIcon.title : ''">
                <frg-inline-svg class="icon" [fill]="fullIcon.fill" [stroke]="fullIcon.stroke" [src]="fullIcon.src">
                </frg-inline-svg>
            </button>
            <div *ngIf="menuLinks" class="menu-links">
                <button [ngClass]="menuLinks.src? 'custom-button' : '' " mat-icon-button [matMenuTriggerFor]="menu" [title]="menuLinks.title ? menuLinks.title : ''">
                    <mat-icon *ngIf="menuLinks.src" >{{menuLinks.src}}</mat-icon>
                    <mat-icon *ngIf="!menuLinks.src"> help_outline</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item *ngFor="let link of menuLinks.links" (click)="openLink(link.link, link.target, link.existingFunction)">
                        <span>{{link.text}}</span>
                    </button>
                </mat-menu>
            </div>
              
        </div>
    </div>
    <div class="body-card">
        <ng-content></ng-content>
    </div>
</div>